<template>
  <v-dialog
    persistent
    :value="showDialog"
    :height="picture.PicHeight"
    :width="picture.PicWidth"
    @hidden="closePictureDialog"
  >
    <v-card>
      <v-toolbar dense class="elevation-0" color="seconadry" dark>
        Preview
        <v-spacer></v-spacer>
        <!-- <v-btn depressed icon title="Download" @click.native="DownloadImage()">
          <v-icon>mdi-download</v-icon>
        </v-btn> -->
        <v-btn title="close" depressed icon @click.native="closePictureDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-row no-gutters>
        <v-col cols="12">
          <v-row no-gutters align="center" justify="center">
            <v-img
              :src="picture.Pic"
              :height="picture.PicHeight"
              :width="picture.PicWidth"
              contain
              class="p-2"
            ></v-img>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "imageViewer",
  props: { picture: {}, showDialog: Boolean },
  mounted() {
    console.log(this.props);
  },
  methods: {
    closePictureDialog() {
      this.$emit("closeImageViewer");
    },

    DownloadImage() {
      const img = new Image();
      img.crossOrigin = "Anonymous"; // Set crossOrigin to handle CORS

      img.onload = () => {
        this.saveImage(img);
      };

      img.src = this.picture.Pic;
    },
    saveImage(img) {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      const link = document.createElement("a");
      link.href = canvas.toDataURL("image/png");
      link.download = "downloaded_image.png";
      link.click();
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/global.scss";
</style>
